module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-4.8e415f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-4.jpg
// module id = 5R3l
// module chunks = 1